import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React, {useEffect, useState} from "react";
import {useIdleTimer} from "react-idle-timer";
import {useLocation} from "react-router-dom";
import {axios_tenant, RedirectTenantLogin} from "../../axios";

let popupTimer;

export default function InActivePopup() {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const popupTimeout = parseInt(process.env.REACT_APP_POPUP_TIMEOUT);
    const inactivityTimeout = parseInt(process.env.REACT_APP_INACTIVITY_TIMEOUT);

    const onIdle = async() => {
        if (["/login", "/invite", "/reset-password"].includes(location.pathname) || location.pathname.startsWith("/superAdmin")) {
            return;
        }
        if(isLastActiveTab()) {
            setOpen(true);
            popupTimer = setTimeout(async () => {
                if(getRemainingTime() <= 0){
                    await axios_tenant.post("/user/logout");
                    RedirectTenantLogin()
                }
            }, popupTimeout);
        } else {
            setOpen(false);
        }
    }

    const {
        getRemainingTime,
        reset,
        isLastActiveTab
    } = useIdleTimer({
        onIdle,
        timeout: inactivityTimeout,
        crossTab: true,
        leaderElection: true,
        syncTimers: 200
    })


    useEffect(() => {

        const handleActivity = () => {
            reset(); // Reset the timer on activity
            if (popupTimer !== undefined) {
                clearTimeout(popupTimer);
            }
            setOpen(false);
        };


        // Add event listeners for mouse movement and key presses   
        window.addEventListener('mousemove', handleActivity);
        window.addEventListener('keypress', handleActivity);

        return () => {
            // Clean up the event listeners on component unmount
            window.removeEventListener('mousemove', handleActivity);
            window.removeEventListener('keypress', handleActivity);
        };
    }, []);


    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description"
        >
            <DialogTitle id="confirmation-dialog-title" sx={{ color: "red", fontWeight: "bold" }}>
                Alert!
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    You will be logged out for inactivity in {popupTimeout / 60000} minutes.
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
}